import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { withLoader } from '@/store/thunks/thunkWrappers';

export const forgotPasswordThunk = createAppAsyncThunk<
  undefined,
  { emailAddress: string },
  { rejectValue: { message: string } }
>(
  'auth/forgotPassword',
  withLoader(
    async({ emailAddress }, { extra: { authService }, rejectWithValue }) => {
      try {
        await authService.forgotPassword({ emailAddress });
        return undefined;
      } catch (caught) {
        const message =
          caught instanceof Error ? caught.message : 'Failed to send reset password email';
        return rejectWithValue({ message });
      }
    }
  )
);
